import React, { useEffect, useState } from "react";
import { Formik, Form, FieldArray } from "formik";
import * as Yup from "yup";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import FieldInput from "../../../CustomComponents/FieldInput";
import LoginLoaderButton from "../../../Common/Loader/LoginLoaderButton";
import { disabledStyle } from "../../../Common/ClickDisable";
import { urlValidation } from "../../../../CloudStorage/CommonFunction";
import BXPImages from "./BXPImages";
import { titlevalidation } from "../../../Common/commonvalidation";
import AsteriskLabel from "../../../Common/AsteriskLabel";

const bxpDatatomap = [
  { title: (<>Project title <AsteriskLabel /></>), name: "title", placeholder: "Enter title" },
  {
    title: (<>Upload file (Upload at least 1 file)  <AsteriskLabel /></>),
    name: "files",
    placeholder: "Drag and drop or Browse file",
  },
  { title: (<>Project URL <AsteriskLabel /></>), name: "url", placeholder: "Type URL " },
];

const validationSchema = Yup.object().shape({
  work_sample: Yup.array().of(
    Yup.object().shape({
      title: titlevalidation.test(
        "conditional-validation",
        "Title is required",
        function (value) {
          const { url, files } = this.parent;
          const allEmpty =
            !value &&
            (!url || url.trim() === "") &&
            (!files || files.length === 0);
          if (allEmpty) return true;
          return !!value && value.trim() !== "";
        }
      ),
      url: Yup.string()
        .test("conditional-url", "Enter a valid URL", function (value) {
          const { title, files } = this.parent;
          const allEmpty =
            (!title || title.trim() === "") &&
            (!value || value.trim() === "") &&
            (!files || files.length === 0);
          if (allEmpty) return true;
          return urlValidation(value);
        })
        .required("URL is required"),
      files: Yup.array()
        .test("conditional-files", "At least one file is required", function (value) {
          const { title, url } = this.parent;
          const allEmpty =
            (!title || title.trim() === "") &&
            (!url || url.trim() === "") &&
            (!value || value.length === 0);
          if (allEmpty) return true;
          return Array.isArray(value) && value.length > 0;
        }),
    })
  ),
});

const BXPWorkSamples = ({ updateindex, bxpData, setbxpData, setActiveTab }) => {
  const [loading, setLoading] = useState(false);
  // Track which index is currently uploading a file
  const [isFileUploading, setIsFileUploading] = useState(null); 

  const initialValues = {
    work_sample: bxpData?.work_sample || [],
  };

  const path = "Assets/scss/FirstTimeUsers.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const handleSubmit = async (values, actions) => {
    setLoading(true);
    setbxpData((prevData) => ({
      ...prevData,
      ...values
    }));

    setLoading(false);
    setActiveTab("PricingTerms");
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  // Determine if any process is blocking the form
  const isFormDisabled = loading || isFileUploading !== null;

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formik) => (
          <Form>
            <div>
              <h1 className="add-work">
                {updateindex != null ? "Edit" : "Add"} work sample (optional)
              </h1>
              <FieldArray name="work_sample">
                {({ push, remove }) => (
                  <>
                    {formik.values.work_sample.map((sample, index) => (
                      <div key={index} className="work-sample">
                        {bxpDatatomap.map((prop, key) => {
                          if (prop.name === "files") {
                            return (
                              <div key={key}>
                                <BXPImages
                                  topindex={index}
                                  values={formik.values?.work_sample[index]?.files}
                                  formik={formik}
                                  name={`work_sample[${index}].files`}
                                  // Pass down a callback to trigger the loader
                                  setUploading={(isUploading) => 
                                    setIsFileUploading(isUploading ? index : null)
                                  }
                                />
                                {/* Render a loader specific to this file input when uploading */}
                                {isFileUploading === index && (
                                  <div className="file-upload-loader mt-2 d-flex align-items-center gap-2">
                                    <LoginLoaderButton /> 
                                    <span style={{ fontSize: "14px", color: "#666" }}>Uploading file...</span>
                                  </div>
                                )}
                              </div>
                            );
                          }
                          return (
                            <FieldInput
                              key={key}
                              title={prop.title}
                              name={`work_sample[${index}].${prop.name}`}
                              placeholder={prop.placeholder}
                            />
                          );
                        })}
                        
                        {formik.values.work_sample.length >= 1 && (
                          <div className="remove-sample">
                            <button
                              type="button"
                              className="btn"
                              onClick={() => remove(index)}
                              // Prevent removal while a file is uploading
                              disabled={isFileUploading === index}
                              style={isFileUploading === index ? disabledStyle : {}}
                            >
                              Remove Sample
                            </button>
                          </div>
                        )}
                      </div>
                    ))}
                    
                    <div className="button-sample">
                      <button
                        type="button"
                        className="btn"
                        onClick={() => push({ title: "", url: "", files: [] })}
                      >
                        Add More Sample
                      </button>
                    </div>
                  </>
                )}
              </FieldArray>

              <div className="button-container">
                <div
                  style={isFormDisabled ? disabledStyle : {}}
                  type="button"
                  className="prev-button btn w-100"
                  onClick={() => !isFormDisabled && setActiveTab("BXPDetails")}
                >
                  Back
                </div>
                <button
                  className="next-button btn w-100"
                  type="submit"
                  disabled={isFormDisabled}
                  style={isFormDisabled ? disabledStyle : {}}
                  onClick={formik.handleSubmit}
                >
                  {/* Show loader on Next button if standard form submission is loading */}
                  {loading ? <LoginLoaderButton /> : "Next"}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default BXPWorkSamples;